import { render, staticRenderFns } from "./TeacherAdminPageTable.vue?vue&type=template&id=67f9db2c&scoped=true&"
import script from "./TeacherAdminPageTable.vue?vue&type=script&lang=js&"
export * from "./TeacherAdminPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9db2c",
  null
  
)

export default component.exports